module.exports = __webpack_public_path__ + "img/cencel@3x.b1cac827.png";